import { call, fork, put, takeEvery } from 'redux-saga/effects';

import * as Actions from '../store/notifications/actions';
import * as Types from '../store/notifications/types';
import { getAccNotifications } from '../services/ElasticApi';
import { ShowToast } from '../store/toast/actions';

const { ActionTypes } = Types;

function* getNotifications(): any {
    try {
        const { data } = yield call(getAccNotifications) || {};
        yield put(Actions.UpdateAccountNotificaitons(data || []));
    } catch (e) {
        const errorMsg = e?.response?.data?.Error ?? e.message;
        yield put(
            ShowToast({
                message: `Error: ${errorMsg}`,
                severity: 'error',
                duration: 6000,
            })
        );
    }
}

function* getNotificationsWatcher(): any {
    yield takeEvery(ActionTypes.GET_ACC_NOTIFICATIONS, getNotifications);
}

const notificationSagas = [fork(getNotificationsWatcher)];

export default notificationSagas;
